<div class="d-flex justify-content-between align-items-center">
    <div class="card-status">
        <h4>Project Type Status</h4>
    </div>
    <div></div>
</div>
<div class="upload_fild">
    <div class="table_responsive">
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2 mat-table-wrapper">
            <ng-container matColumnDef="statusName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status Name</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.name }}
                </td>
            </ng-container>

            <ng-container matColumnDef="statusName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status Name</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.name }}
                </td>
            </ng-container>

            <ng-container matColumnDef="color">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Colour</th>
                <td mat-cell *matCellDef="let element">
                    <!-- <span class="color_box" [style.background]="element.colour"></span> -->
                    <input disabled style="width: 15px; height: 15px" [(colorPicker)]="element.colour" [style.background]="element.colour" />
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
    </div>
</div>
